import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import auth from "../../../common/utility/auth";

import atributoService from '../../../service/administracion/atributoService';
import { REG_ATRI } from "../../../common/types/parametroType";

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            estados: estadoMock.values,
            tipoCampos: [],
            filter: {
                nombre: '',
                estado: '',
                idTipoAtributo: 1,
                idTipoCampo: 0,
                activeKey: "1",
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            idTipoCampo: 0,
            detalleItem: [],
            tipoCampos: [],
            idTipoAtributo: 1,
            isLista: false,
            activeKey: "1",
        };
    };

    handleClearFilters = () => {
        var filter = {
            nombre: '',
            estado: '',
            idTipoAtributo: 1,
            idTipoCampo: 0,
            activeKey: "1",
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await atributoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Marca.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await atributoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Marca.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await atributoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await atributoService.eliminar(values);
            else
                response = await atributoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/

    handleNew = () => {

        var params = auth.user().parametros;

        var flagRegistro = params.filter((m) => m.abreviatura === REG_ATRI)[0].valor === "1" ? true : false;
        if (!flagRegistro) {
            message.warning('Opción no disponible en su plan actual, contacte a un asesor comercial.');
            return false;
          }
        var formValues = this.fetchEmptyFormValues();
        formValues.tipoCampos = this.state.tipoCampos;
        formValues.activeKey = this.state.formValues.activeKey;
        formValues.isLista = false;

        if (formValues.activeKey === "2") {
            var item = this.state.tipoCampos.filter((m) => m.abreviatura == "LI");
            formValues.idTipoCampo = item.length > 0 ? item[0].id : 0;
            formValues.isLista = true;
        }

        this.setState({ visible: true, formValues });
    };


    handleEdit = async (values) => {
        const response = await atributoService.obtenerPorId(values.id);
        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues();
            formValues.tipoCampos = this.state.tipoCampos;
            formValues.id = response.id;
            formValues.nombre = response.nombre;
            formValues.idTipoCampo = response.idTipoCampo;
            formValues.idTipoAtributo = response.idTipoAtributo;
            formValues.activeKey = this.state.formValues.activeKey;

            formValues.detalleItem = response.items == null ? [] : JSON.parse(response.items);

            formValues.isLista = formValues.detalleItem.length > 0 ? true : false;

            this.setState({
                visible: true,
                formValues
            });
        }
    };

    handleSave = (values, form) => {
        if (this.state.formValues.activeKey == "1") {
            if (this.state.pagination.data.length >= 7  && this.state.formValues.id == 0) {
                dialog.warning("Solo se puede registrar maximo 7 atributos");
                return false;
            }
        }

        if (this.state.formValues.activeKey == "2") {

            if (this.state.pagination.data.length >= 2 && this.state.formValues.id == 0) {
                dialog.warning("Solo se puede registrar maximo 2 variantes");
                return false;
            }
        }

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await atributoService.registrar(values);
            else
                response = await atributoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleChangeForm = async (property, value, form) => {
        var isLista = property == "LI" ? true : false;

        this.setState({
            formValues: {
                ...this.state.formValues,
                idTipoCampo: value,
                isLista
            }
        },
            () => {
                form.setFieldsValue({
                    idTipoCampo: { key: value },
                    isLista: isLista
                });
            });


    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {

        var detalleItem = this.state.formValues.detalleItem;

        var item = {
            identifier: global.fetchUniqueCode(),
            nombre: ''
        };

        detalleItem.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                detalleItem: detalleItem
            },
        });
    };

    handleRemoverDetalle = (item) => {
        var detalleItem = this.state.formValues.detalleItem.filter((m) => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                detalleItem: detalleItem,
            },
        });
    };


    handleChangeTab = async (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key,
                idTipoAtributo: key == "1" ? 1 : 2
            },
            filter: {
                ...this.state.filter,
                activeKey: key,
                idTipoCampo: key == "1" ? this.state.filter.idTipoCampo : 0,
                idTipoAtributo: key == "1" ? 1 : 2

            },
        });
        setTimeout(() => {
            this._handlePagination(this.state.filter);

        }, 100);
    };


    async componentDidMount() {
        this._initPagination(this.state.filter, atributoService.paginacion);
        const tipoCampos = await atributoService.listarTipoCampo();

        this.setState({
            loadingSource: false,
            tipoCampos: tipoCampos ? tipoCampos : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.formValues.activeKey == "1" ? "Atributos" : "Variantes"}
                    onNew={this.handleNew}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    tipoCampos={this.state.tipoCampos}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}

                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemove={this.handleRemoverDetalle}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChange={this.handleChangeForm}

                />
            </div>
        );
    };
}